import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const buttonContainerStyle = {
  float: 'right'
};

const textAreaStyle = {
  resize: 'none',
  width: '100%',
  height: '6em'
};

const getDefaultMessage = defaultText => {
  const defaultMsg = `${defaultText} - `;

  return defaultMsg;
};

const initialDialogState = {
  commentText: '',
  commentType: 'CoreEncounter',
  commentId: 0,
  editMode: false,
  canBeDeleted: false,
  canBeEdited: false,
  isHoldComment: false,
  isActive: false
};

const AddCommentToPatientDialog = ({
  isOpen,
  closeDialog,
  commentSourceId,
  commentEncounterId,
  addCommentToPatient,
  addCommentToEncounter,
  updateComment,
  deleteComment,
  setCommentInactive,
  dateOfService,
  commentId,
  commentContent,
  commentType,
  editMode,
  canBeDeleted,
  canBeEdited,
  isHoldComment,
  isActive
}) => {
  const [dialogState, setDialogState] = useState(initialDialogState);

  const dialogCommentText = (commentId !== undefined && commentId !== null && commentId !== 0) ? commentContent : getDefaultMessage(dateOfService);

  useEffect(() => {
    setDialogState({ ...dialogState, commentText: dialogCommentText, commentType, commentId: commentId, editMode: editMode, canBeDeleted: canBeDeleted, canBeEdited: canBeEdited, isHoldComment: isHoldComment, isActive: isActive });
  }, [commentSourceId, isOpen]);

  const saveComment = (text, commentType, commentId, isHoldComment) => {
    if (commentId > 0){
      let commentDto = { commentId: commentId, commentText: text, isHoldComment, commentSourceId: commentId, commentSourceType: commentType };
      updateComment(commentDto);
    }
    else {
      if (commentType === 'Patient') {
        addCommentToPatient(commentSourceId, text);
      }
      else {
        addCommentToEncounter(commentEncounterId, text);
      }
    }
  };

  const deactivateComment = (text, commentType, commentId, isHoldComment) => {
    let commentDto = { commentId: commentId, commentText: text, isHoldComment, commentSourceId: commentId, commentSourceType: commentType };

    setCommentInactive(commentDto);
  }

  const deleteTheComment = commentId => {
    if (confirm("Delete this comment?")) deleteComment(commentId);
  }

  const getOption = (optionValue, optionLabel, selectedValue) => {
    if (optionValue === selectedValue) {
      return (<option value={optionValue} selected>{optionLabel}</option>);
    }
    return (<option value={optionValue}>{optionLabel}</option>);
  }

  const activeButtonName = dialogState.isActive ? "Set Inactive" : "Set Active";
  const dialogTitle = dialogState.editMode ? "Edit Comment" : "Add Comment";
  const saveButtonName = dialogState.editMode ? "Update" : "Add";

  return (
      <Dialog
        open={isOpen}
        maxWidth="lg"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <div style={rootDialogStyle}>
          <div>
            <h3 style={{ textAlign: 'center' }}>{dialogTitle}</h3>
          </div>

          <div>
            <span>
              <strong>Type: </strong>
              <select
                disabled={dialogState.editMode}
                onChange={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  const val = e.target.value;
                  setDialogState({ ...dialogState, commentType: val })
                }}
              >
                {getOption('CoreEncounter', 'Encounter', commentType)}
                {getOption('Patient', 'Patient', commentType)}
              </select>&nbsp;&nbsp;
              <textarea
                readOnly={(dialogState.editMode && !dialogState.canBeEdited) || !dialogState.isActive}
                style={textAreaStyle}
                value={dialogState.commentText}
                maxLength="400"
                onChange={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  const val = e.target.value;
                  setDialogState({ ...dialogState, commentText: val });
                }}
              />
              <span>{dialogState.commentText.length}/400</span>
            </span>
          </div>

          {/* cancel & ok buttons */}
          <div style={buttonContainerStyle}>
            <button
              onClick={closeDialog}
            >
              Cancel
            </button>

            <button
              onClick={() => {
                saveComment(dialogState.commentText, dialogState.commentType, commentId, isHoldComment);
              }}
              disabled={dialogState.selectedEncoding === null || (editMode && !canBeEdited) || isActive === false}
            >
              {saveButtonName}
            </button>
            {editMode && canBeDeleted &&
              <button
                onClick={() => {
                  deactivateComment(dialogState.commentText, dialogState.commentType, commentId, isHoldComment);
                }}
              >
                {activeButtonName}
              </button>
            }
            {editMode && canBeDeleted && <button onClick={() => deleteTheComment(dialogState.commentId)}>Delete Comment</button>}
          </div>
        </div>
      </Dialog>
  );
};

AddCommentToPatientDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  commentSourceId: PropTypes.number.isRequired,
  addCommentToPatient: PropTypes.func.isRequired,
  addCommentToEncounter: PropTypes.func.isRequired
};

export default AddCommentToPatientDialog;
